import Component from "vue-class-component";

Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate"
]);
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "bootstrap";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faPlay,
  faPause,
  faForward,
  faBackward,
  faStepBackward,
  faStepForward,
  faCarrot,
  faHome,
  faHeart as faHeartSolid,
  faHistory,
  faChevronLeft,
  faAngleLeft,
  faAngleUp,
  faAngleRight,
  faAngleDown
} from "@fortawesome/free-solid-svg-icons";
import {
  faClock,
  faHeart as faHeartRegular
} from "@fortawesome/free-regular-svg-icons";
import { i18n } from "@/plugins/i18n/vue-i18n-plugin";
Vue.component("font-awesome-icon", FontAwesomeIcon);

library.add(
  faClock,
  faPlay,
  faPause,
  faForward,
  faBackward,
  faStepBackward,
  faStepForward,
  faCarrot,
  faHome,
  faHeartSolid,
  faHeartRegular,
  faHistory,
  faChevronLeft,
  faAngleLeft,
  faAngleUp,
  faAngleRight,
  faAngleDown
);

Vue.config.productionTip = false;

export const EventBus = new Vue();

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount("#app");
